import * as React from 'react';
import AlertMessage from '../alertMessage/alertMessage';
import Translate from '../../functions/translate';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../modal/modalDialog';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import Button from "@material-ui/core/Button";
import { TreeNodeModel } from '../../../models/treeNodeModel';
import { CategoryModel } from "../../../models/category/categoryModel";
import Spinner from '../../../common/components/spinner/spinner';
import Snackbar from "../../../common/components/snackbar/snackbar";
import { Tree } from 'primereact/tree'

interface IProps {
  isVisible: boolean,
  saveClick: any,
  cancelClick: any,
  currentCategoryId?: number,
  categories: Array<CategoryModel>;
}

interface IState {
  selectedCategoryId?: number,
  validationMessage: string,
  isLoading: boolean;
  error: any;
  selectionKeys: any;
  expandedKeys: any;
  selectedCategoryIds: Array<number>;
  categories: Array<CategoryModel>;
  treeCategories: Array<TreeNodeModel>;
}

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        width: '100%'
      },
      root: {
        width: '100%'
      }
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: '0px'
      }
    },
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '90% !important',

      },
      paperFullWidth: {
        minHeight: '400px',
        maxHeight: '400px',
        width: '40%'
      }
    },
  },
  palette: {
    primary: blue
  }
})

class CategoryDialog extends React.Component<IProps, IState> {
  snackbar: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      validationMessage: '',
      error: null,
      selectedCategoryId: this.props.currentCategoryId,
      categories: this.props.categories ? this.props.categories : new Array<CategoryModel>(0),
      treeCategories: new Array<TreeNodeModel>(0),
      selectedCategoryIds: new Array<number>(0),
      selectionKeys: null,
      expandedKeys: null,
    };
  }

  componentDidMount() {
    this.initCategoryTree();
  }

  initCategoryTree() {
    this.setState({ isLoading: true });
    this.createTree();
    this.showSelectedCategory(this.state.selectedCategoryId);
    this.setState({ isLoading: false });
  }

  createTree() {
    let subTree = this.createSubTree(null);
    this.setState({
      treeCategories: subTree
    });
  }

  createSubTree(parentId) {
    let subTree = new Array<TreeNodeModel>(0);

    this.state.categories
      .filter(f => parentId ? f.parentId === parentId : f.parentId === null)
      .sort((a, b) => (a.orderNo > b.orderNo) ? 1 : (b.orderNo > a.orderNo ? -1 : 0))
      .map(f => {
        let node = new TreeNodeModel();
        node.key = f.id.toString();
        node.label = f.name;
        node.data = { ...f };
        if (this.state.categories.some(a => a.parentId === f.id)) {
          node.children = this.createSubTree(f.id);
        };

        subTree.push(node);
        return 0;
      });

    return subTree;
  }

  showSelectedCategory = (categoryId) => {
    // if (!categoryId) {
    //   this.expandMainParents({});
    //   //return;
    // }

    let selectedCategory = this.state.categories.find(p => p.id === categoryId);
    if (!selectedCategory || !selectedCategory.parentId) {
      this.expandMainParents({});
      return;
    }

    this.expandParentNodes(selectedCategory, this.state.expandedKeys);

    this.handleSelectionChange(selectedCategory.id.toString());
  }

  expandMainParents = (expandedKeys) => {
    expandedKeys = expandedKeys ? expandedKeys : {};

    let mainCategories = this.state.categories.filter(p => p.parentId === null);
    if (mainCategories && mainCategories.length > 0) {
      mainCategories.forEach(c => {
        expandedKeys[c.id.toString()] = true;
      })
      this.setState({ expandedKeys: expandedKeys });
    }
  }

  expandParentNodes = (category: CategoryModel, expandedKeys) => {
    expandedKeys = expandedKeys ? expandedKeys : {};

    let expandedParent = this.state.categories.find(p => p.id === category.parentId);
    if (expandedParent) {
      expandedKeys[expandedParent.id.toString()] = true;
      this.expandParentNodes(expandedParent, expandedKeys);
    }

    this.setState({ expandedKeys: expandedKeys });
  }

  handleSelectionChange = (value) => {
    let categoryIds = new Array<number>(0);
    if (this.state.selectedCategoryIds.some(v => v === value)) {
      value = null;
      categoryIds = new Array<number>(0);
    } else {
      categoryIds.push(+value);
    }
    this.setState({
      selectionKeys: value,
      selectedCategoryIds: categoryIds.slice()
    });
  }

  handleSaveButton = (id) => {
    this.props.saveClick(id);
  };

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  nodeTemplate(node) {
    if (node.data.levelNo === 1) {
      if (!node.data.isActive)
        return (
          <b style={{ opacity: 0.5 }}>{node.label}</b>
        )

      return (
        <b>{node.label}</b>
      )
    }

    if (!node.data.isActive) {
      return (
        <div style={{ opacity: 0.5 }}>{node.label}</div>
      )
    }

    return (
      <>{node.label}</>
    )
  }

  public render() {

    const { selectedCategoryId, isLoading, treeCategories, selectionKeys, selectedCategoryIds, expandedKeys } = this.state;

    let header = '';

    if (!selectedCategoryId) {
      header = Translate('AddCategory');
    } else {
      header = Translate('EditCategory');
    }

    let isAddButtonDisabled = false;
    if (selectedCategoryIds && selectedCategoryIds.length > 0) {
      isAddButtonDisabled = treeCategories.some(c => c.data.levelNo === 1 && c.data.id === selectedCategoryIds[0]);
    }
    else {
      isAddButtonDisabled = true;
    }

    return (
      <MuiThemeProvider theme={theme}>
        <Dialog
          open={this.props.isVisible}
          onClose={this.handleCancelButton}
          fullWidth
          disableBackdropClick={true}
        >
          <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{header}</Modal.DialogTitle>
          <Modal.DialogContent>
            {isLoading ? <Spinner /> : null}
            <Snackbar ref={(el) => this.snackbar = el} />
            {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
            <div>
              <Tree
                value={treeCategories}
                style={{ width: "100%" }}
                selectionMode="single"
                selectionKeys={selectionKeys}
                expandedKeys={expandedKeys}
                onToggle={e => this.setState({ expandedKeys: e.value })}
                onSelectionChange={e => this.handleSelectionChange(e.value)}
                nodeTemplate={this.nodeTemplate}
              />
            </div>
          </Modal.DialogContent>
          <Modal.DialogActions>
            <div>
              <Button onClick={this.handleCancelButton} variant="contained" style={{ marginRight: 10 }}>
                {Translate("Cancel")}
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={(e) => this.handleSaveButton(selectedCategoryIds[0])}
                disabled={isAddButtonDisabled}
              >
                {Translate("Add")}
              </Button>
            </div>
          </Modal.DialogActions>
        </Dialog >
      </MuiThemeProvider>
    )
  }
}

export default CategoryDialog;